import React, { useState, useEffect } from "react"
import Button from "../../../../components/Button"
import { useHistory } from "react-router"
import { copyServices, getCenterDetails } from "../../../../core/services/api"
import "../../CenterAdmin/AddNewReferral/AddNewReferral.scss"
import Select from "react-select"
import Toast from "components/Toast"
import { useSelector } from "react-redux"
import customSelectStyles from "components/CustomSelect/CustomSelectStyle"




function CopyServices() {
  const history = useHistory()
  const [centerDetail, setCenterDetail] = useState<any>()
  const [fromcenterId, setFromCenterId] = useState<any>()
  const [tocenterId, setToCenterId] = useState<any>()
  const [displayToast, toggleDisplayToast] = useState<any>()
  // @ts-ignore
  let readOnly = useSelector((state) => state?.user?.readOnly);

  const copyServicesFunction = () => {
    if (fromcenterId !== tocenterId) {
      copyServices(fromcenterId, tocenterId)
        .then((res: any) => {
          toggleDisplayToast({ text: "Services have been copied successfully", type: "success" });
        })
        .catch((err: any) => {
          console.log(err);
          toggleDisplayToast({ text: "Error in copying the services", type: "error" });
        });
    } else {
      toggleDisplayToast({ text: "Cannot copy services: Source and target are the same", type: "error" });
    }
  };

  useEffect(() => {
    if (fromcenterId && tocenterId && fromcenterId == tocenterId) {
      toggleDisplayToast({
        text: `Both the centers cannot be the same`,
        type: "warning"
      });
    }
  }, [fromcenterId, tocenterId]);

  const handlecopyServicesFunction = (() => {
    toggleDisplayToast({
      // @ts-ignore
      text: `Are you sure you want to copy these services?`,
      type: "warning",
      onClickText: "Yes",
      // @ts-ignore

    })
  })



  const dropdownCenters = centerDetail?.map((val: any) => {
    return {
      label: val?.centerName,
      value: val?.id
    }
  })



  useEffect(() => {
    //setRole(userDetail?.currentRole);
    getCenterDetails().then((res: any) => {
      setCenterDetail(res);
    }).catch((err: any) => {
      console.log(err, "error")
    })
  }, [])


  return (
    <div className="add-new-referral-container">
      <div className="add-new-referral-heading">
        <div
          className="approval-back-image"
          onClick={() => {
            history.push('/Service')
            history.push({
              pathname: "/Service",
              state: { type: 'Center', value: 1, previousCenterId: "", previousCenterName: "" },
            })
          }}
        >
          <img
            src={'../../../assets/images/back-icon.svg'}
            height={'60px'}
            width={'60px'}
            alt="back button"
            className="back_button"
          />
        </div>

        <div className="add-new-text">Copy  Services</div>

      </div>
      <div className="add-new-referral-details">

        <div className="row nameDetails">
          <div className="col-2">
            <label className="textlabel">Copy From Center Id:</label>
          </div>
          <div className="col-3">
            <div className="custom-react-select">
              <Select
                className="select-payment"
                name="modeOfPayment"
                defaultValue={{
                  label: "",
                  value: ""
                }}
                styles={customSelectStyles()}
                isDisabled={readOnly}
                options={dropdownCenters}
                onChange={(evnt) => {
                  setFromCenterId(evnt?.value);
                }}
              />
            </div>
          </div>
        </div>

        <div className="row nameDetails">
          <div className="col-2">
            <label className="textlabel">Copy To Center Id:</label>
          </div>
          <div className="col-3">
            <div className="custom-react-select">
              <Select
                className="select-payment"
                name="modeOfPayment"
                defaultValue={{
                  label: "",
                  value: ""
                }}
                styles={customSelectStyles()}
                isDisabled={readOnly}
                options={dropdownCenters}
                onChange={(evnt) => {
                  setToCenterId(evnt?.value);

                }}
              />
            </div>

          </div>
        </div>

        <div className="button-alignment">
          <div>
            <Button
              text="Cancel"
              type={"button"}
              outline={true}
              disabled={readOnly}
              onClick={() => history.push(`/Service`)}
              id="add-new-service-cancel"
            />
          </div>
          <div>

            <Button text="Save"
              disabled={readOnly}
              onClick={() => handlecopyServicesFunction()} id="add-new-service-save" />
          </div>
        </div>


      </div>
      {displayToast && (
        <Toast
          textMessage={displayToast?.text}
          type={displayToast?.type}
          onClose={() => {
            toggleDisplayToast(false)
            history.push(`/copyServices`)
          }}
          onCloseText="Close"
          onClickText={
            // @ts-ignore
            displayToast?.onClickText ? displayToast?.onClickText : null
          }
          onClick={() =>

            // @ts-ignore
            copyServicesFunction()

          }
        />
      )}

    </div >
  )
}
export default CopyServices
